import React, { useState } from 'react'
import { ConfigCatProvider, PollingMode, SettingValue, useFeatureFlag, User } from 'configcat-react'
import { RootState } from 'src/store'
import { useSelector } from 'react-redux'
import { getAuthUser } from 'src/utils/auth'
import { CONFIG } from 'src/utils/config'

function BushelConfigCatProvider({ children }) {
  const settings = useSelector(({ settings }: RootState) => settings)
  const [defaultUser] = useState(() => getConfigCatUser(settings.companySlug))

  return (
    <ConfigCatProvider
      sdkKey={CONFIG.configcat_sdk_key}
      pollingMode={PollingMode.AutoPoll}
      options={{
        defaultUser,
        baseUrl: CONFIG.configcat_base_url,
      }}
    >
      {children}
    </ConfigCatProvider>
  )
}

function getConfigCatUser(slug) {
  const authUser = getAuthUser()

  return new User(authUser?.bushel_id ?? 'anonymous', undefined, undefined, {
    CompanySlug: slug,
    company_slug: slug,
  })
}

export function useFeatureFlagWithUser(key: string, defaultValue: SettingValue) {
  const settings = useSelector(({ settings }: RootState) => settings)
  return useFeatureFlag(key, defaultValue, getConfigCatUser(settings.companySlug))
}

export default BushelConfigCatProvider
